<template>
  <svg class="ui-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <path v-for="(path, i) in paths" :key="i" :d="path" />
  </svg>
</template>
<script>
const icons = {
  hash: ['M9 3 7 21M17 3l-2 18M4 8h17M3 16h17'],
  speaker: ['M11 4 5 9H2v6h3l6 5V4Z', 'M15 8a6 6 0 0 1 0 8M18 4a11 11 0 0 1 0 16'],
  headphones: ['M3 14v-3a9 9 0 0 1 18 0v3', 'M3 12h3v8H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1ZM21 12h-3v8h3a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Z'],
  mic: ['M9 5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0V5Z', 'M5 11v1a7 7 0 0 0 14 0v-1M12 19v3M8 22h8'],
  micOff: ['M9 5a3 3 0 0 1 6 0v7M9 9v3a3 3 0 0 0 5 2M5 11v1a7 7 0 0 0 12 5M19 11v1M12 19v3M8 22h8M2 2l20 20'],
  deafened: ['M3 14v-3a9 9 0 0 1 16-5M21 10v4M3 12h3v8H3v-8ZM18 16v4h3M2 2l20 20'],
  settings: ['m10 2-1 3-3 1-3-1-2 4 3 2v3l-2 2 2 4 3-1 3 1 1 3h4l1-3 3-1 2 1 2-4-2-2v-3l2-2-2-4-3 1-2-1-1-3h-5Z', 'M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'],
  users: ['M15 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM3 21v-3a6 6 0 0 1 12 0v3H3ZM17 3a4 4 0 0 1 0 8M18 14a5 5 0 0 1 4 5v2h-4'],
  invite: ['M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM2 21v-3a6 6 0 0 1 11-3M19 12v8M15 16h8'],
  plus: ['M12 5v14M5 12h14'], close: ['m6 6 12 12M6 18 18 6'], chevron: ['m6 9 6 6 6-6'],
  search: ['M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-2 5 6 6'],
  send: ['m3 3 19 9-19 9 4-9-4-9ZM7 12h15'],
  screen: ['M3 3h18v13H3V3ZM8 21h8M12 16v5M8 10l4-4 4 4M12 6v7'],
  disconnect: ['M3 14a16 16 0 0 1 18 0l1 2-3 4-4-2v-3H9v3l-4 2-3-4 1-2Z'],
  link: ['m10 13 4-4M8 15l-2 2a3 3 0 0 1-4-4l5-5a3 3 0 0 1 4 0M13 16a3 3 0 0 0 4 0l5-5a3 3 0 0 0-4-4l-2 2'],
  copy: ['M8 8h13v13H8V8ZM16 8V3H3v13h5'], check: ['m4 12 5 5L20 6'],
  crown: ['m2 6 5 4 5-7 5 7 5-4-3 13H5L2 6ZM5 22h14'],
  compass: ['M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM16 8l-3 5-5 3 3-5 5-3Z'],
  chat: ['M3 3h18v14H9l-6 4V3ZM7 8h10M7 12h7'],
  shield: ['m12 2 9 4v6c0 6-9 10-9 10S3 18 3 12V6l9-4Z', 'm8 12 3 3 5-6'],
  home: ['M5 6a20 20 0 0 1 14 0l3 12-6 3-1-3H9l-1 3-6-3L5 6Z', 'M9 12h.01M15 12h.01M8 16c2 1 6 1 8 0']
}
export default { props: { name: { type: String, default: 'hash' } }, computed: { paths() { return icons[this.name] || icons.hash } } }
</script>
